import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';

const useUpdateTransferOperation = () => {
  const { enqueueSnackbar } = useSnackbar();

  const updateRequest = (
    payload,
    getTransferOperationList,
    setIsEditModalOpen,
    setEditLoading,
  ) => {
    axiosClient
      .put(`Operation/Transfer/Update`, {
        guid: payload.guid,
        title: payload.title,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`ویرایش با موفقیت انجام شد`, { variant: 'success' });
          getTransferOperationList?.();
          setIsEditModalOpen?.(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setEditLoading?.(false));
  };

  return { updateRequest };
};

export default useUpdateTransferOperation;
